import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9001/api'
export const getMasterReservedWord = (keyword) => {
  const url = `${API_ROOT}/portal/reserved-word?keyword=${keyword}`
  return doGet(url)
}

export const saveMasterReservedWord = (request) => {
  const url = `${API_ROOT}/portal/reserved-word`
  return doPost(url, request)
}

export const updateMasterReservedWord = (id, request) => {
  const url = `${API_ROOT}/portal/reserved-word/${id}`
  return doPut(url, request)
}

export const deleteMasterReservedWord = (id) => {
  const url = `${API_ROOT}/portal/reserved-word/${id}`
  return doDelete(url)
}
